import styled from 'styled-components';

import { StyledHeaderControls } from '../cameraStreamWidget.styles.ts';

/**
 * Wraps the divider between the bell and the sensor readings. Extending StyledHeaderControls makes
 * it fade in and out with the readings it separates, while the bell itself stays visible.
 */
export const StyledHeaderDividerFade = styled(StyledHeaderControls)`
  margin-left: 0;
`;
